import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const AutomatedUpselling = () => {
  useEffect(() => {
    analytics.track('Feature Page View', { feature: 'Automated Upselling' });
  }, []);

  return (
    <SEOPageLayout
      title="Automated Upselling Tools - Increase Profit Margins | QuoteTier"
      description="Let your software do the selling. Automatically suggest premium add-ons and upgrades within your quotes to boost average deal size without being pushy."
      canonical="/features/automated-upselling-tools"
      ogTitle="Upsell Every Single Job Automatically"
      ogDescription="Don't rely on your technicians to remember to upsell. Build it into the quote and let the customer choose the upgrades they want."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              The Salesperson That <span className="text-primary font-bold">Never Sleeps</span>
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Automatically present high-margin add-ons and upgrades on every single quote.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Start Upselling Automatically
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">How It Works</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Interactive Add-ons</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Include "Recommended Add-ons" sections where clients can simply click to add premium services to their total.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Visual Upgrades</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Show photos of what the upgrade looks like. A picture of a premium thermostat sells better than a text line item.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Psychological Nudges</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Use "Popular" tags and pre-selected options (with opt-out) to gently guide customers toward higher value packages.</p></CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Boost Your Margins Today</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Start Free
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default AutomatedUpselling;
